<div *ngFor="let tooth of teeth; trackBy: trackByToothId" class="tooth-container">
	<rx-intuitive-tooth
		[tooth]="tooth"
		[displayNumber]="tooth.toothNumberInSystem"
		[symbolId]="tooth.svgSymbolId"
		[numberPosition]="numberPosition"
	></rx-intuitive-tooth>
</div>
